import { SIGNUP_HIRER_STEP_STORE } from "src/utils/constants";
import { create } from "zustand";
const {
  subscribeWithSelector,
  devtools,
  persist,
  createJSONStorage,
} = require("zustand/middleware");

const clearLocalStorageState = () => {
  localStorage.removeItem(SIGNUP_HIRER_STEP_STORE);
};

export const useClientSignUpSteps = create(
  subscribeWithSelector(
    devtools(
      persist(
        (set, get) => ({
          activeStep: 1,
          setActiveStep: (step) =>
            set({ activeStep: step }, false, "setActiveStep"),

          jobType: undefined,
          setJobType: (jobType) => set({ jobType }, false, "setJobType"),

          basics: {},
          setBasics: (basics) => {
            set({ basics }, false, "setBasics");
          },

          // USER JOB TYPE
          userJobType: undefined,
          updateUserJobType: (userJobType) =>
            set({ userJobType }, false, "updateUserJobType"),

          // USER STACK
          userStack: undefined,
          updateUserStack: (userStack) =>
            set({ userStack }, false, "updateUserStack"),

          // USER LEVEL
          userLevel: undefined,
          updateUserLevel: (userLevel) =>
            set({ userLevel }, false, "updateUserLevel"),

          // USER SKILLS
          userSkills: [],
          updateUserSkills: (userSkills) =>
            set({ userSkills }, false, "updateUserSkills"),


          // USER WORK TYPE
          workType: [],
          updateWorkType: (workType) =>
            set({ workType }, false, "workType"),

          // USER LANGUAGES
          userLanguages: [],
          updateUserLanguages: (userLanguages) =>
            set({ userLanguages }, false, "updateUserLanguages"),

          // USER FRAMEWORKS
          userFrameworks: [],
          updateUserFrameworks: (userFrameworks) =>
            set({ userFrameworks }, false, "updateUserFrameworks"),

          // Client Extras
          extras: {},
          updateExtras: (extras) => {
            set({ extras: { ...get().extras, ...extras } }, false, "setExtras");
          },
          clearStore: () => {
            clearLocalStorageState()
          }
        }),
        {
          name: SIGNUP_HIRER_STEP_STORE,
          storage: createJSONStorage(() => localStorage),
        }
      )
    )
  )
);
